export default __webpack_public_path__ + "static/media/question.54bfa38c.svg";